// SEE: https://getslick.atlassian.net/browse/GS-11131?focusedCommentId=15154

import BUSINESS_TYPE from 'constants/salon/businessType.const';

const BUSINESS_NAME = Object.freeze({
  [BUSINESS_TYPE.other]: 'Other',
  //
  [BUSINESS_TYPE.salonHair]: 'Hair salon',
  [BUSINESS_TYPE.salonBeauty]: 'Beauty salon',
  [BUSINESS_TYPE.salonHnB]: 'Hair & beauty salon',
  //
  [BUSINESS_TYPE.barbers]: 'Barbers',
  [BUSINESS_TYPE.hbnb]: 'Hair, beauty & barbering',
  //
  [BUSINESS_TYPE.mobileHair]: 'Mobile / home hairdresser',
  [BUSINESS_TYPE.mobileBeauty]: 'Mobile / home beautician',
  //
  [BUSINESS_TYPE.medical]: 'Aesthetics / Medical',
  [BUSINESS_TYPE.physio]: 'Physio therapy',
  //
  [BUSINESS_TYPE.groomDog]: 'Dog grooming',
  //
  [BUSINESS_TYPE.train]: 'College / Training Academy',
});

// noinspection JSUnusedGlobalSymbols
export default BUSINESS_NAME;
